import { FolderId } from '@business/entities/file';
import { FormId } from '@business/entities/form';

import { ManagementFormResponse, FormForwardUserStatus, FormForwardType, FetchManagementFormRequest } from '@business/entities/managementForms';
import { Endpoint } from '../endpoint';
import { UserId } from '@business/entities/account';

export function createForm(name: string, folderId: FolderId, form: FormId, userId: UserId) {
  return Endpoint.post<ManagementFormResponse>(`@gc/management-form`, { data: { name, folderId, form, userId } });
}

export function fetchForms(params: FetchManagementFormRequest) {
  return Endpoint.get<ManagementFormResponse[]>(`@gc/management-form`, { params });
}

export function fetchForm(id: FormId) {
  return Endpoint.get<ManagementFormResponse>(`@gc/management-form/form/${id}`);
}

export function saveFormValues(id: string, values: string, status: FormForwardUserStatus) {
  return Endpoint.post<ManagementFormResponse>(`@gc/management-form/save-values/${id}`, { data: { values, status } });
}

export function forwardForm(id: FormId, users: UserId[], comment?: string, type?: FormForwardType) {
  return Endpoint.post<ManagementFormResponse>(`@gc/management-form/forward`, { data: { id, users, comment, type } });
}

export function updateForwardedStatus(id: string, status: FormForwardUserStatus, finalize?: boolean) {
  return Endpoint.patch<ManagementFormResponse>(`@gc/management-form/forwarded-status/${id}`, { data: { status, finalize } });
}

export function updateFormName(id: string, name: string) {
  return Endpoint.patch<ManagementFormResponse>(`@gc/management-form/form-name/${id}`, { data: { name } });
}

export function toggleArchive(id: string) {
  return Endpoint.patch<ManagementFormResponse>(`@gc/management-form/toggle-archive/${id}`);
}

export function toggleArchiveReceived(id: FormId) {
  return Endpoint.get<void>(`@gc/management-form/toggle-archive-received/${id}`);
}
